//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapMutations } from 'vuex'
export default {
  name:'ExcretionFraction_Mg',
  data() {
    return {
      defaultJson:{
        "Serum magnesium": "血清镁",
        "Pl Creatinine": "血肌酐",
        "Magnesium urine": "尿镁",
        "U Creatinine": "尿肌酐"
      },
      form:{
        serum_magnesium:'',
        creatinine:'',
        magnesium_urine:'',
        ucreat:'',
      },
      hasScore:false,
      disabled:false,
    }
  },
  created () {
    this.hideLoad()
  },
  methods: {
    ...mapMutations(['hideLoad']),
  },
  computed: {
    /** 计算公式结果 */
    score() {
      let self = this
      let form = JSON.parse(JSON.stringify(self.form))
      let flag = true
      for (const key in form) {
        if (form.hasOwnProperty(key)) {
          if (!form[key]) {
            flag = false
          } else {
            if (form[key]=='---') {
              flag = false
            } else {
              form[key] = Number(form[key])
            }
          }
        }
      }
      if (!flag) {
        self.hasScore = false
        return '--'
      } else {
        console.log(form)
        // 排泄分数（镁）=（尿Mg*血Cr）/0.7*血Mg*尿Cr
        let result = (form.magnesium_urine * form.creatinine) / (0.7 * form.serum_magnesium * form.ucreat)
        console.log(result)
        self.hasScore = true
        return String((result*100).toFixed(2))
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/pages/formulas/Renal/ExcretionFraction_Mg.vue